import { useDataClient } from "../hooks/client.hooks";
import { PriceAdjustmentResponseDTO } from "../open-api";

// TODO: Replace with service
export const usePriceAdjustmentsForOrganization = (organizationalUnitId: string) =>
  useDataClient<PriceAdjustmentResponseDTO[]>(
    `/api/organizational-unit/${organizationalUnitId}/price-adjustments?includeAvailable=false`
  );
